import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect } from "react";
import { Chart } from "react-chartjs-2";
import { BarController, BarElement, CategoryScale, Chart as ChartJs, LinearScale, Tooltip } from "chart.js";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Text, TrendArrow, Grid, Card } from "~/components-shared";
import { StatusStateEnum } from "~/types/enums";
import analyticsSelectors from "~/store/analytics/selectors";
import analyticsActionCreators from "~/store/analytics/actions";
import activityCharts from "~/charts/activities";
import styled, { useTheme } from "styled-components";
ChartJs.register(BarController, CategoryScale, LinearScale, BarElement, Tooltip);
const StyledGrid = styled(Grid)`
  border: 1px solid ${_ref => {
  let {
    theme
  } = _ref;
  return theme.colors.borders.primary;
}};
  border-radius: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.shape.borderRadius.primary;
}};

  & > *:not(:last-child) {
    border-right: 1px solid ${_ref3 => {
  let {
    theme
  } = _ref3;
  return theme.colors.borders.primary;
}};
  }
`;
const TrendWrapper = styled.div`
  max-width: 130px;
  border-top: 1px solid ${_ref4 => {
  let {
    theme
  } = _ref4;
  return theme.colors.borders.primary;
}};
`;
const StyledText = styled(Text)`
  vertical-align: sub;
`;
const ActiveMonthlyMembersCard = _ref5 => {
  let {
    communities = [],
    ...rest
  } = _ref5;
  const theme = useTheme();
  const {
    t
  } = useTranslation();
  const status = useSelector(analyticsSelectors.getActiveMonthlyMembersStatus);
  const analytics = useSelector(analyticsSelectors.getActiveMonthlyMembers);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(analyticsActionCreators.fetchActiveMonthlyMembersStarted(communities));
  }, [dispatch, JSON.stringify(communities)]);
  const summaryData = [{
    title: t("ActivityOverview.totalMembers"),
    value: analytics?.totalMembers.value || 0,
    prevValue: analytics?.totalMembers.prevValue || 0
  }, {
    title: t("ActivityOverview.messages"),
    value: analytics?.messages.value || 0,
    prevValue: analytics?.messages.prevValue || 0
  }, {
    title: t("ActivityOverview.attendedEvent"),
    value: analytics?.attendedEvent.value || 0,
    prevValue: analytics?.attendedEvent.prevValue || 0
  }, {
    title: t("ActivityOverview.reactions"),
    value: analytics?.reactions.value || 0,
    prevValue: analytics?.reactions.prevValue || 0
  }];
  return /*#__PURE__*/React.createElement(Card, _extends({
    loading: status === StatusStateEnum.LOADING
  }, rest), /*#__PURE__*/React.createElement(Grid, {
    cols: 2,
    gap: 10,
    template: "60% 40%"
  }, /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement("div", {
    style: {
      height: 160
    }
  }, analytics && /*#__PURE__*/React.createElement(Chart, activityCharts.activeMonthlyMembersProps(theme, analytics)))), /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Text, {
    element: "h1",
    s: {
      mb: 2
    },
    display: "inline-block"
  }, analytics?.activeMonthlyUsers.value || 0), /*#__PURE__*/React.createElement(TrendArrow, {
    value: analytics?.activeMonthlyUsers.value || 0,
    prevValue: analytics?.activeMonthlyUsers.prevValue || 0
  }), /*#__PURE__*/React.createElement(TrendWrapper, null, analytics && /*#__PURE__*/React.createElement(Chart, activityCharts.trendChartProps(theme, analytics)), /*#__PURE__*/React.createElement(Text, {
    element: "span",
    color: "textSecondary",
    weight: "light"
  }, t("ActivityOverview.monthlyTrends"))))), /*#__PURE__*/React.createElement(StyledGrid, {
    cols: 4,
    s: {
      mt: 10
    },
    equal: true
  }, summaryData.map(item => /*#__PURE__*/React.createElement(Grid.Cell, {
    key: item.title,
    s: {
      py: 6,
      px: 4
    }
  }, /*#__PURE__*/React.createElement(StyledText, {
    element: "span",
    display: "block",
    fontSize: 3,
    color: "textSecondary",
    s: {
      mb: 4
    }
  }, item.title), /*#__PURE__*/React.createElement(Text, {
    element: "span",
    fontSize: 8,
    weight: "bold"
  }, item.value), /*#__PURE__*/React.createElement(TrendArrow, {
    value: item.value,
    prevValue: item.prevValue
  })))));
};
export default ActiveMonthlyMembersCard;